//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Perfil from "./perfil/Perfil"
import ModulosList from "./components/ModulosList";
import TagsList from "./tags/TagsList";

export default {
  components: {
    Perfil,
    ModulosList,
    TagsList,
  },

  data() {
    return {
      tab: "solicitudes.bpb",
      tabs: [
        { name: "Verificaciones", component: () => import('./verificaciones/Verificaciones') },

        // Solicitudes
        { name: "solicitudes.bpb",     component: () => import('./solicitudes/Bienparabien') },
        { name: "solicitudes.skypark", component: () => import('./solicitudes/Skypark')     },
        { name: "solicitudes.sadasi",  component: () => import('./solicitudes/Sadasi')      },
        { name: "solicitudes.ihm",  component: () => import('./solicitudes/IHM')      },
        { name: "solicitudes.monte_piedad",  component: () => import('./solicitudes/MontePiedad')},
        { name: "solicitudes.hsbc",  component: () => import('./solicitudes/HSBC')},

        // { name: "solicitudes.onisvida",  component: () => import('./solicitudes/OnisVida')      },

        // Tareas
        { name: "LeadsDigital",   component: () => import('./tareas/LeadsDigital')         },
        { name: "Cobranzas",   component: () => import('./tareas/Cobranzas')         },

        { name: "Facturacion",    component: () => import('./components/Facturacion')    },
        { name: "Cursos",           component: () => import('./aula/Cursos')       },
        { name: "Actividad",      component: () => import('./components/Actividad')      },
        { name: "Red",            component: () => import('./components/RedList')        },
        { name: "Notas",          component: () => import('./notas/NotasTable')        },
      ],
    }
  },

  watch: {
    // Hack: $router no detecta el cambio del parametro
    ["$route.params.promotor"](promotor) {
      location.reload();
    },
  },
}
